import { NotificationDto } from '../../interfaces/NotificationDto';
import { Notification } from '../../interfaces/Notification';

export default function transformNotifications(notificationDtos: NotificationDto[]): Notification[] {
  const notifications: Notification[] = [];
  if (Array.isArray(notificationDtos)) {
    notificationDtos?.forEach((dto) => {
      notifications.push({
        id: dto.id,
        text: dto.text,
        creationDateUtc: dto.creationDateUtc,
        isDeleting: false,
        sector: dto.sector,
        seen: dto.seen,
        type: dto.type,
        url: dto.url,
        visited: dto.visited,
        source: 'notification',
      });
    });
    return notifications;
  }
  return [];
}
